module.exports = __webpack_public_path__ + "static/img/5.8202723f.jpg";